import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/:warehouseId/products/`;
const pathById = `${pathBase}:productId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const products = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
};
